import React from 'react';

import { CustomIcon } from '../Icon/Icon';

import { Button } from './Button';


export const DownloadButton = ({ title, onClick, svg, large, disabled = false, className }) => (
  <Button
    additions={ [ 'fit-content', large ? 'lgDownload' : 'download' ] }
    onClick={ onClick }
    disabled={ disabled }
    vendorClass={ className }
  >
    <CustomIcon
      svg={ svg ?? 'DOWNLOAD' }
      svgProps={ large ? { width: '18', height: '18' } : { width: '12', height: '12' } }
    />
    <p>{ title }</p>
  </Button>
);
